import { IUser } from '../interface/user';
import { IUserPost } from '../interface/user';
export class User implements IUser{
    constructor(
        public UserId : number,
        public UserName : string,
        public UserPassword : string,
        public UserRole : string,
        public UserRoleId : number,
        public IsDeleted?: number 
    ){ }
}

export class UserPost implements IUserPost{
    constructor(
        public  PostId : number,
        public  HeaderText : string,
        public Text : string,
        public UserId : number,
        public CreatedDate : string,
        public ImagePath: string,
        public VideoPath: string,
        public Type: string
    ){ }
}



// WEBPACK FOOTER //
// ./src/app/section/user/model/user.ts